import React from "react";
import DMModal from "./DMModal";
import CloseIcon from "@material-ui/icons/Close";
import { Divider } from "@material-ui/core";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";

function WarningPopup({
  open = false,
  onClose = () => {},
  onSave = () => {},
  saveButtonLabel = "Save",
  title = "",
  description = "",
  hideBtn = false,
  width = "450px",
  intl=null
}) {
  return (
    <DMModal open={open} onClose={onClose}>
      <div style={{ ...styles.popup, width: width }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div
            style={{
              flex: "1",
              fontSize: "16px",
              fontWeight: "700",
              textAlign: "left",
            }}
          >
            {title || ""}
          </div>
          <div>
            <CloseIcon
              style={{
                marginBottom: "-6px",
                paddingLeft: "4px",
                color: "#BAC0D0",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={onClose}
            />
          </div>
        </div>
        <Divider />
        <div style={styles.content}>
          <div
            style={{ ...styles.text, marginBottom: hideBtn ? "0px" : "50px" }}
          >
            {description || "-"}
          </div>

          {!hideBtn && (
            <div style={{ display: "flex", width: "100%" }}>
              <button style={styles.saveButton} onClick={onSave}>
                {saveButtonLabel}
              </button>
              <button style={styles.cancelbutton} onClick={onClose}>
                {injectIntlTranslation(intl, "cancelBtnLabel", "Cancel")}
              </button>
            </div>
          )}
        </div>
      </div>
    </DMModal>
  );
}

export default injectIntl(WarningPopup);

const styles = {
  popup: {
    backgroundColor: "white",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    padding: "20px",
    textAlign: "center",
    margin: "200px auto",
    outline: "none",
    fontFamily: "Roboto",
  },
  content: {
    textAlign: "left",
    marginTop: "15px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
    color: "#333",
  },
  text: {
    color: "#333",
    fontWeight: "500",
  },
  saveButton: {
    minWidth: "150px",
    padding: "10px",
    backgroundColor: "#0e3b8d",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    marginLeft: "auto",
  },
  cancelbutton: {
    width: "150px",
    padding: "10px",
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #000",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    marginLeft: "15px",
  },
};
